import React, { useEffect, useContext } from "react";
import classnames from 'classnames';
import { useHistory } from "react-router-dom";
import {
  UPLOAD_CATEGORY_TYPE,
  CATEGORY_LIST,
  MAX_UPLOAD_COUNT_PER_CATEGORY,
  Context
} from '../common/js/constant';
import { isObjectEmpty } from '../common/js/util';
import UploadImgButton from '../components/UploadImgButton';
import useQueryImageListHook from '../common/hooks/useQueryImageListHook';
import { deleteSpecImageFile } from '../common/js/request';
import useQuery from '../../../hooks/useQuery';
import styles from "./index.module.scss";

// 图片上传页
export default function UploadPictures() {
  const history = useHistory();
  const { state } = useContext(Context);
  const urlParams = useQuery();
  const orderNumber = urlParams.get('orderNumber') || '';
  const { cateImgList, setCateImgList } = useQueryImageListHook({ orderNumber });

  // 上传回调
  const onUploadCallback = (category, img) => {
    updateSpecCateImgList('add', category, img);
  }

  useEffect(() => {
    document.title = "现场照片";
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  // 更新指定类型列表数据（增加/删除）
  const updateSpecCateImgList = (action, category, img) => {
    const _targetCateList = cateImgList[category] || [];
    const { fileId, url, path, fileName } = img;
    let _updatedList;
    if (action === 'add') {
      _updatedList = _targetCateList.concat([], {
        fileId,
        url,
        fileName,
        path,
        category
      })
    } else if(action === 'remove') {
      _updatedList = _targetCateList.filter(imgItem => imgItem.fileId !== fileId);
    }
    
    setCateImgList(Object.assign({}, {
      ...cateImgList,
      [category]: _updatedList ? _updatedList : _targetCateList
    }))
  }

  useEffect(() => {
    if (isObjectEmpty(state.uploadedImageList)) return;
    setCateImgList(state.uploadedImageList)
  }, [state.uploadedImageList, setCateImgList]);

  // 删除指定照片
  const onDeleteSpecImage = ({id, category}) => {
    updateSpecCateImgList('remove', category, { fileId: id });
    deleteSpecImageFile({ fileId: id });
  }

  const onUploadPageCompleted = () => {
    history.goBack();
  }

  const onViewGuideTips = () => {
    history.push('/rescue-new/guide');
  }

  return (
    <div className={styles['upload-pics-container']}>
      <div className={styles['upload-field']}>
        {
          CATEGORY_LIST.map((cateType, index) => {
            const cateTarget = UPLOAD_CATEGORY_TYPE[cateType];
            const specCateImgList = cateImgList[cateTarget.value] || [];
            return (
              <div
                key={index}
                className={
                classnames(`
                  ${styles['upload-category-field']}
                  ${styles['cate-back-bumper']}
                  `)
                }
                data-type={cateTarget.value}
              >
                <div className={styles['cate-title']}>
                  {cateTarget.title}
                </div>
                <div className={styles['photo-list-field']}>
                  {
                    specCateImgList.map(imgItem => {
                      return (
                        <PhotoItem key={imgItem.fileId} id={imgItem.fileId} url={imgItem.url} name={imgItem.fileName} category={cateTarget.value} deleteFn={onDeleteSpecImage} />
                      )
                    })
                  }
                  {
                    // 大于特定数量不展示上传按钮
                    specCateImgList.length < MAX_UPLOAD_COUNT_PER_CATEGORY && (
                      <UploadImgButton orderNumber={orderNumber} category={cateTarget.value} onUploadCompleted={onUploadCallback} />
                    )
                  }
                </div>
              </div>
            )
          })
        }
      </div>
      <div className={styles['desc-field']}>
        <div className={styles['guide-text']}>
          * 为了更快速地获取车辆现场情况，给出合理的救援方案，还需要在您确认安全的情况，协助上传现场照片。
          <span className={styles['more-guide-detail']} onClick={onViewGuideTips}>『更多指引』</span>
        </div>
      </div>
      <div className={
        classnames(`${styles['action-field']}`)
        
      }>
        <div className={styles['confirm-btn']} onClick={onUploadPageCompleted}>
          完成
        </div>
      </div>
    </div>
  );
}

function PhotoItem ({ id, url, name, category, deleteFn }) {
  return (
    <div className={styles['photo-item-wrapper']}>
      <div className={styles['close-icon-wrapper']} onClick={() => deleteFn({id, category})}>
        <svg className={styles['close-icon']} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
          <title>closeIcon</title>
          <g id="closeIcon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <circle id="椭圆形" fill="#BDCBDF" fillRule="nonzero" cx="16" cy="16" r="12"/>
              <g id="编组" transform="translate(9.000000, 9.000000)" fill="#FFFFFF" fillRule="nonzero">
                  <path d="M1,1 C1.55228475,0.44771525 2.44771525,0.44771525 3,1 L13,11 C13.5522847,11.5522847 13.5522847,12.4477153 13,13 C12.4477153,13.5522847 11.5522847,13.5522847 11,13 L1,3 C0.44771525,2.44771525 0.44771525,1.55228475 1,1 Z" id="Rectangle"/>
                  <path d="M13,1 C12.4477153,0.44771525 11.5522847,0.44771525 11,1 L1,11 C0.44771525,11.5522847 0.44771525,12.4477153 1,13 C1.55228475,13.5522847 2.44771525,13.5522847 3,13 L13,3 C13.5522847,2.44771525 13.5522847,1.55228475 13,1 Z" id="Rectangle"/>
              </g>
          </g>
        </svg>
      </div>
      <img
        className={styles['photo-img-item']}
        src={url}
        alt={name}
      />
    </div>
  )
}
